// extracted by mini-css-extract-plugin
module.exports = {"panelList":"PanelList_panelList__1KkQn","headline":"PanelList_headline__1Wa1U","complianceCode":"PanelList_complianceCode__2j04C"};